"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getUnitPriceObject = (attribute, enumVal, iteration) => {
  const key = Array.isArray(attribute.prices) ? iteration : enumVal;
  if (attribute.prices && attribute.prices[key]) {
    return attribute.prices[key];
  }
  return null;
};
var _default = exports.default = getUnitPriceObject;